module.exports = "<div class=\"wrapper\">\n  <h3 class=\"heading\"> {{ heading }}</h3>\n</div>\n"